import { CodeBlock as TiptapCodeBlock } from "@tiptap/extension-code-block";

export interface CodeBlockAttrs {
  cellId: string;
  cellGroup: string;
  language: string | null;
  outputTimestamp: string | null;
}

export const CodeBlock = TiptapCodeBlock.extend<CodeBlockAttrs>({
  addAttributes() {
    return {
      ...this.parent?.(),
      cellId: {
        default: null,
      },
      cellGroup: {
        default: null,
      },
      outputTimestamp: {
        default: null,
      },
    };
  },
});
